export default "__VITE_ASSET__ce3a0cef__"